import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Row, Col, List, Tabs, Button, Avatar, Modal, Carousel, Card, Icon, Drawer } from 'antd';
import { description } from '../admin/events/Constants';
import Calendar from './Calendar';
import CardEvent from './CardEvent';
import Search from './Search';
import Item from './Item';
import moment from 'moment';
import API, { IMAGES_URL } from '../../helper/api/Api';
import LoadingBar from 'react-redux-loading-bar';
import Badge from './Badge';

const TabPane = Tabs.TabPane;

export class ListEvent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: [],
      top: [],
      visible_modal: this.props.id != null,
      id_modal: this.props.id || null,
      from: null,
      to: null,
    };
  };

  static propTypes = {
    event: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  showModal(show, id = null) {
    if (show && !this.props.isAuth)
      this.props.loginModal()
    else {
      this.setState({
        visible_modal: show
      });

      if (id) this.setState({ id_modal: id })

      window.history.pushState('Event', 'Description', id ? '/event/' + id : '/');
    }
  }

  handleChangeFromDate(momentDate, date) {
    //change the page + request API
    this.handleChange({ from: date === "" ? null : date });
  }

  handleChangeToDate(momentDate, date) {
    //change the page + request API
    this.handleChange({ to: date === "" ? null : date });
  }


  handleChangeSearch(keys, values) {
    this.handleChange({ filters: values });
  }

  handleChange(change) {
    this.setState(change);
    let args = { ...this.state, ...change };
    delete args.top;
    delete args.visible_modal;

    args = { ...args, categories: 'True', images: 'True' }
    this.props.actions.getEvents("ASC", args)
  }

  componentWillMount() {
    this.props.actions.getEvents("ASC", { categories: 'True', images: 'True', restricted: 'True' });
    this.props.actions.getEvents("ASC", { categories: 'True', images: 'True', restricted: 'True', obsolete: 'True', from: moment().subtract(1, 'years').format('DD/MM/YYYY') });
    API.get('/topevent/list').then((res) => this.setState({ top: res.data }));
    //this.props.actions.getEvents("ASC", { obsolete: 'True', categories: 'True', images: 'True' });
  }

  render() {

    return (
      <div>
        {
          this.state.top.length === 0 ? '' :
            <div>
              <Row>
                <Col span={16} offset={4} className="title-home">
                  <h3><Icon type="ellipsis" />    Événements à la une    <Icon type="ellipsis" /></h3>
                </Col>
              </Row>
              <Carousel
                className="home-carousel-top-event"
                autoplay
              >
                {this.state.top.map((top, index) =>
                  <div style={{ width: '65%' }} key={index}>
                    <Card
                      className="card-top-event"
                      hoverable
                      cover={<img alt="card_top" src={IMAGES_URL(top.event.images)} style={{objectFit: "cover", heigth: 222, width: "100%"}}/>}
                      actions={[
                        <div>
                          <Button className="ui-btn" onClick={() => this.showModal(true, top.event.id)} >
                            Détails de l'événement
                          </Button>
                        </div>]}
                    >
                      <Card.Meta
                        title={top.event.title}
                        description={description(top.event.description, 90)}
                      />
                      <div className="bookmark">
                        <p className="day">{moment(top.event.openAt, "YYYY-MM-DD HH:mm", 'fr').format('DD')}</p>
                        <p className="month">{moment(top.event.openAt, "YYYY-MM-DD HH:mm", 'fr').format('MMM')}</p>
                      </div>
                      <div className="subtitle">
                        {top.name}
                      </div>
                    </Card>
                  </div>
                )}
              </Carousel>
            </div>
        }
        <Row style={{ marginTop: 30 }}>
          <Col span={16} offset={4} className="title-home">
            <h3><Icon type="minus" />    Retrouver tous les événements   <Icon type="minus" /></h3>
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Search
              fromDate={this.handleChangeFromDate.bind(this)}
              toDate={this.handleChangeToDate.bind(this)}
              select={this.handleChangeSearch.bind(this)}
              categoriesSelected={this.state.filters} />
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Tabs defaultActiveKey="1" >
              <TabPane tab="LISTE DES ÉVÉNEMENTS" key="1">
                <LoadingBar className="loading-bar" style={{ marginTop: "-18px" }} />
                <List
                  //loading={this.props.event.status.getEvents.pending}
                  size="large"
                  pagination={{ pageSize: 8 }}
                  //header={(this.state.date ? <div className="date">{this.state.date}</div> : <div>{moment().format("DD/MM/YYYY", "fr")}</div>)}
                  dataSource={this.props.event.list}
                  renderItem={item => (<CardEvent key={item.id} item={item} showModal={(show, id) => this.showModal(show, id)} />)}
                />
              </TabPane>
              <TabPane tab="CALENDRIER DES ÉVÉNEMENTS" key="2">
                <LoadingBar className="loading-bar" style={{ marginTop: "-18px" }} />
                <Row type="flex">
                  <Col span={24}>
                    <Calendar
                      event={this.props.event}
                      showModal={(show, id) => this.showModal(show, id)}
                    />
                  </Col>
                  {/*
                  <Drawer
                    title="ÉVÈNEMENT SÉLECTIONNÉ"
                    placement="right"
                    closable={true}
                    onClose={() => this.setState({ drawerVisible: false })}
                    visible={this.state.drawerVisible}
                  >
                    <List
                      itemLayout="horizontal"
                      dataSource={this.props.event.list.filter(e => this.state.calendar_is_day && this.state.calendar_events_id.includes(e.id))}
                      renderItem={(event, index) => (
                        <List.Item key={index} actions={[<Button onClick={() => this.showModal(true, event.id)}>Voir</Button>]}>
                          <List.Item.Meta
                            avatar={<Avatar src={IMAGES_URL(event.images)} />}
                            title={<Badge event={event} />}
                          />
                        </List.Item>
                      )}
                    />
                  </Drawer>
                  */}
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
        <Modal
          className="modal-event"
          visible={this.state.visible_modal}
          onOk={() => this.showModal(false)}
          onCancel={() => this.showModal(false)}
        >
          <Item id={this.state.id_modal} />
        </Modal>
      </div>
    );

  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    event: state.event,
    isAuth: state.authentification.isAuth
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListEvent);


// WEBPACK FOOTER //
// ./src/features/event/List.js